class OpinionSwiper {
    constructor() {
        this.blockOpinion = document.querySelector('.block-opinion');
        if (!this.blockOpinion) {
            return;
        }
        this.prevArrow = this.blockOpinion.querySelector('.prev-btn');
        this.nextArrow = this.blockOpinion.querySelector('.next-btn');
        this.swiperOpinion = new Swiper(".swiper-opinion", {
            slidesPerView: 1,
            loop: true,

            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            },
        });
    }
}